<template>
  <v-card class="fill-height">
    <v-card-text class="details">
      <div class="details__row" v-for="(value, key) in documentsInfo" :key="key" v-show="value">
        <div class="details__cell details__cell--key">{{ key }}:</div>
        <div class="details__cell details__cell--value">
          <span v-if="key === 'Upload Date'">{{ value | moment("MMMM D YYYY") }}</span>
          <span v-else-if="Array.isArray(value)">
            <template v-if="value.length > 0">
              <div v-for="item in value" :key="item.id">{{ item.name }}</div>
            </template>
            <div v-else>None</div>
          </span>
          <span v-else>{{ value }}</span>
        </div>
      </div>
    </v-card-text>

    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn :to="`/admin/categories/${selectedCategory.url_slug}`">Back to Category</v-btn>
      <v-btn color="primary" to="edit" append>Edit</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      document: false,
      dataPoints: {
        "Document Name": "display_name",
        "File Type": "file_ext",
        "File Size": "file_size",
        Categories: "categories",
        "Permission Groups": "permission_groups",
        "Upload Date": "created_at"
        // "File Name": "file_name",
        // "File Path": "full_path",
        // ID: "id"
      }
    };
  },

  computed: {
    ...mapGetters("document_center", ["selectedDocument", "selectedCategory"]),
    documentsInfo() {
      let data = {};

      _.forEach(this.dataPoints, (fieldKey, key) => {
        let value = this.getObjectValue(fieldKey, this.document);

        if (fieldKey === "permission_groups") {
          value = (value || []).map(({ name, description, id }) => ({
            id,
            name: `${name} - ${description}`
          }));
        } else if (fieldKey === "categories") {
          value = this.getFullCategoryNames(value);
        }

        data[key] = value;
      });

      return data;
    },

    documentId() {
      return this.$route.params.id;
    }
  },

  methods: {
    getFullCategoryNames(categories) {
      return (categories || []).map(category => {
        const names = [category.name];

        let parent = category.parent;
        while (parent) {
          names.unshift(parent.name);
          parent = parent.parent;
        }

        return {
          ...category,
          name: names.join(" -> ")
        };
      });
    }
  },

  created() {
    this.$set(this, "document", this.selectedDocument(this.documentId));
  }
};
</script>
